// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ImportedSignalDraftResolutionStatusSchema = z.enum(['PENDING','PENDING_TARGET_TYPE','PENDING_APP','PENDING_ENDPOINT','AWAITING_PROBE','PENDING_UNSUPPORTED_TARGET','AWAITING_NETWORK_VERIFICATION','PENDING_NETWORK','PENDING_NETWORK_ASSET','PROMOTED','DUPLICATE','REJECTED','ERRORED','NON_SIGNAL','CANCELLED'] as const);

export type ImportedSignalDraftResolutionStatusType = `${z.infer<typeof ImportedSignalDraftResolutionStatusSchema>}`

export default ImportedSignalDraftResolutionStatusSchema;
